import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: white;
`;

export const Header = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
`;

export const Logo = styled.img`
  height: 60px;
  width: 60px;
  margin-left: 20px;
`;

export const Content = styled.div`
  height: calc(100vh-80px);
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.div`
  width: 60vw;
  height: 80vh;
  position: relative;
  display: grid;
  grid-template-rows: 80px auto;
  overflow: hidden;
`;
/*
export const WrapImg = styled.div`
  background: white;
  width: 100%;
  height: 100%;
  object-fit: cover;
  //Put a box shadow instead
  border-radius: 10px 0px 0px 10px;
  position: relative;
  overflow: hidden;
`;

export const Img = styled.img`
  position: absolute;
  height: auto;
  width: 100%;
  bottom: -10px;
  right: 0;
  left: 0;
`;*/

//Border radius: top left --> top right --> bottom right --> bottom left
export const Slider = styled.div`
  border-radius: 20px 20px 0px 0px;
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const FormContainer = styled.div`
  background: rgb(34, 217, 118);
  background: linear-gradient(
    196deg,
    rgba(34, 217, 118, 1) 0%,
    rgba(24, 24, 24, 1) 84%
  );
  border-radius: 20px;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const FormLogin = styled.form`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  /*left: 1200px;
  top: 300px;*/
  transition: all 0.5s ease-in;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  width: 100%;

  div {
    width: 80%;
    display: grid;
    background-color: white;
    height: 40px;
    align-items: center;
    justify-items: center;
    border-radius: 10px;
    grid-template-columns: 100%;
    grid-template-rows: auto;
    flex-direction: row;

    label {
      color: black;
      grid-column: 1/2;
      grid-row: 1/2;
    }

    input {
      width: 80%;
      height: 100%;
      text-align: center;
      z-index: 5;
      background: transparent;
      border: none;
      grid-column: 1/2;
      grid-row: 1/2;

      &:focus,
      &:active {
        outline: none;
      }
    }
  }

  button {
    padding: 20px 80px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    background: rgba(34, 217, 118, 1);
    color: white;

    &:hover {
      transform: scale(1.05);
      background: #44e991;
    }
  }
`;

export const FormSignUp = styled.form`
  position: absolute;
  left: 1200px;
  top: 300px;

  transition: all 0.5s ease-in;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 60vw;
  height: calc(80vh - 120px);

  div {
    width: 80%;
    height: 40px;
    display: grid;
    background-color: white;
    align-items: center;
    justify-items: center;
    border-radius: 10px;
    grid-template-columns: 100%;
    grid-template-rows: auto;
    flex-direction: row;

    label {
      color: black;
      grid-column: 1/2;
      grid-row: 1/2;
    }

    input {
      width: auto;
      background: transparent;
      border: none;
      z-index: 5;
      height: 100%;
      text-align: center;

      width: 80%;
      grid-column: 1/2;
      grid-row: 1/2;

      &:focus,
      &:active {
        outline: none;
      }
    }
  }

  button {
    padding: 20px 80px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    background: rgba(34, 217, 118, 1);
    color: white;

    &:hover {
      transform: scale(1.05);
      background: #44e991;
    }
  }
`;

export const ButtonBar = styled.div`
  height: 60px;
  width: 50%;
  border-radius: 10px;
  border: 0.2px solid #181818;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

export const Buttons = styled.button`
  background-color: transparent;
  border: none;
  z-index: 5;
  cursor: pointer;
  color: #181818;

  &:first-child {
    color: white;
    font-weight: bold;
  }

  transition: all 100ms ease-in-out 250ms;
`;

export const ActiveBar = styled.div`
  height: 60px;
  background-color: #22d976;
  width: 25%;
  border-radius: 10px;
  opacity: 0.9;
  position: absolute;
  left: 25%; //Will need to change this to 75%
  z-index: 3;
  transition: left 400ms ease-in-out;
`;
